module.exports = __webpack_public_path__ + "img/welcomeys.962abc51.png";